// Import all ts files here
import '../styles/index.scss';
import './templates/cart';
import { docReady } from './helpers/docReady';
import { carousel } from './sections/carousel';
import { greensparkAPI } from './sections/greenspark';
import { splitImages } from './sections/split-images-with-text';
docReady(() => {
    // Initiate JS
    carousel();
    greensparkAPI();
    splitImages();
});
